import { number, shape, string } from 'prop-types';
import React, { PureComponent } from 'react';
import { Image, StyleSheet, View } from 'react-native';

import { C, LAYOUT, SHAPE } from '../../../../common';
import { Location, NextPage, Uri } from '../../../../components';
import { Consumer } from '../../../../context';
import { LAYOUT as REACTOR, THEME } from '../../../../reactor/common';
import { Button, Motion, Text } from '../../../../reactor/components';
import styles from './Title.style';

const { COLOR } = THEME;
const { PAGE_OFFSET, PAGE_OFFSET_HORIZONTAL } = C;

class Title extends PureComponent {
  static propTypes = {
    index: number.isRequired,
    info: shape({}),
    image: string,
    link: shape(SHAPE.LINK),
    location: shape(SHAPE.LOCATION),
    subtitle: string,
    title: string.isRequired,
    visibility: number.isRequired,
  };

  static defaultProps = {
    info: undefined,
    image: undefined,
    link: undefined,
    location: undefined,
    subtitle: undefined,
  };


  render() {
    const {
      props: {
        index, info, image, link, location, subtitle, title, visibility = 1, ...inherit
      },
    } = this;
    const { VIEWPORT: { LANDSCAPE } } = REACTOR;
    const reverse = info || (inherit.style ? inherit.style.includes('reverse') : undefined);

    let subtitleLevel = 6;
    let titleLevel = 4;
    if (reverse) titleLevel = 5;

    if (LANDSCAPE) {
      subtitleLevel = 4;
      titleLevel = title.length > 34 ? 1 : 0;
      if (reverse) titleLevel = 2;
    }

    return (
      <View style={StyleSheet.flatten([styles.container, LAYOUT.STYLE.pageTitle])}>
        <View style={[styles.content, { marginHorizontal: LANDSCAPE ? PAGE_OFFSET_HORIZONTAL : PAGE_OFFSET }]}>
          { title && (
            <Text color={inherit.color} headline level={titleLevel}>
              {title}
            </Text>)}
          { subtitle && (
            <Text color={inherit.color} headline level={subtitleLevel} style={reverse && styles.subtitleFirst}>
              {subtitle}
            </Text>)}
          { info && (
            <Consumer>
              { ({ onInfo }) => (
                <Button
                  color={COLOR.WHITE}
                  responsive
                  rounded
                  style={styles.button}
                  title="+ Info"
                  onPress={() => onInfo(info)}
                />)}
            </Consumer>)}
        </View>

        <View style={styles.bottom}>
          { location && <Location {...location} color={inherit.color} style={styles.location} /> }

          { image && <Image resizeMode="contain" source={{ uri: image }} style={[styles.image, styles.safeArea]} /> }

          { index === 0 && (
            <Motion preset="fade" visible={visibility > 0.75}>
              <NextPage onPress={inherit.onPress} motion={false} />
            </Motion>) }

          { LANDSCAPE && link && (
            <Motion preset="fade" style={styles.safeArea} visible={visibility > 0.65}>
              <View style={styles.linkContainer}>
                { link.image
                  && (
                  <Uri eventProps={{ target: link.uri }} target="_blank" to={link.uri}>
                    <Image resizeMode="contain" source={{ uri: link.image }} style={styles.linkImage} />
                  </Uri>
                  ) }
                <Text color={inherit.color} caption level={2} style={styles.linkText}>
                  {link.title}
                </Text>
              </View>
            </Motion>) }
        </View>
      </View>
    );
  }
}

export default Title;
